import request from '@/router/axios'


/**
 * 获取三十天交易统计数据
 * @param params
 * @returns {*}
 */
export const getThirtyDays = (params) => {
  return request({
    method: 'get',
    url: `/api/statistics/thirty_days`,
    params: params
  })
}

/**
 * 获取指定日期交易统计数据
 * @param params
 * @returns {*}
 */
export const getStatisticsDay = (params) => {
  return request({
    method: 'get',
    url: `/api/statistics/day`,
    params: params
  })
}

/**
 * 校验链接是否有效
 * @param data
 * @returns {*}
 */
export const checkTime = (data) => {
  return request({
    method: 'post',
    url: `/api/statistics/checkTime`,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/iwin11Statistics.js